import { Helmet } from 'react-helmet-async';
import { styled } from '@mui/material/styles';
import { Container, Tabs, Tab, Grid } from '@mui/material';
import { ChangeEvent, useState } from 'react';
import PageTitleWrapper from 'src/components/PageTitleWrapper';
import PageHeader from '../common/PageHeader';
import { useSelector } from 'react-redux';
import { RootState } from 'src/redux-store/appStore';
import PermitDetails from './PermitDetails/PermitDetails';
import ServiceDetails from './PermitFeeDetails/ServiceDetails';

const TabsWrapper = styled(Tabs)(
  () => `
      .MuiTabs-scrollableX {
        overflow-x: auto !important;
      }
  `
);

const PermitManagement: React.FC = () => {
  // Default tab logic
  const defaultTab = 'permit_details';
  const [currentTab, setCurrentTab] = useState<string>(defaultTab);
  const userData = useSelector((state: RootState) => state.user.userDetails);

  const user = {
    name: `${userData.FirstName} ${userData.LastName}`,
    jobTitle: userData.UserRole === 'Vendor' ? 'User' : userData.UserRole
  };

  const tabs = [
    { value: 'permit_details', label: 'Service Details' },
    { value: 'service_details', label: 'Service Fee History' }
  ];

  // Handle tab change
  const handleTabsChange = (
    event: ChangeEvent<unknown>,
    value: string
  ): void => {
    setCurrentTab(value);
  };

  return (
    <>
      <Helmet>
        <title>Township Management</title>
      </Helmet>
      <PageTitleWrapper>
        <PageHeader
          userName={user.name}
          jobTitle={user.jobTitle}
          pageTitle="Permit Management"
          description=""
        />
      </PageTitleWrapper>
      <Container maxWidth="lg">
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="stretch"
          spacing={3}
        >
          <Grid item xs={12}>
            <TabsWrapper
              onChange={handleTabsChange}
              value={currentTab}
              variant="scrollable"
              scrollButtons="auto"
              textColor="primary"
              indicatorColor="primary"
            >
              {tabs.map((tab) => (
                <Tab key={tab.value} label={tab.label} value={tab.value} />
              ))}
            </TabsWrapper>
          </Grid>
          <Grid item xs={12}>
            {currentTab === 'permit_details' && <PermitDetails />}
            {currentTab === 'service_details' && <ServiceDetails />}
          </Grid>
        </Grid>
      </Container>
      {/* <Footer /> */}
    </>
  );
};

export default PermitManagement;
